import {Button} from '@mui/material';
import {ApiErrorFeedback} from '../../common/ApiErrorFeedback';
import {useReceiptTracking} from './useReceiptTracking';

export function ReceiptTrackingError({tracking}: {tracking: ReturnType<typeof useReceiptTracking>}) {
    return <ApiErrorFeedback error={tracking.error} retryAction={<Button onClick={() => tracking.refetch()}>Retry</Button>}/>;
}
